import { Flex } from 'foundations-components/components/Flex';
import { HR } from 'foundations-components/transitional/components/HR';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { LogicGroupNames } from '../../filterQueryFormat/logic/LogicGroup';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MessageKeys = {
  [LogicGroupNames.AND]: 'newCustomerDataFilters.logicOperator.and',
  [LogicGroupNames.OR]: 'newCustomerDataFilters.logicOperator.or'
};
const LogicGroupsDivider = props => {
  const {
    logicOperator,
    paddingBlockStart = '400',
    paddingBlockEnd = '400'
  } = props;
  if (!logicOperator) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    paddingBlockStart: paddingBlockStart,
    paddingBlockEnd: paddingBlockEnd,
    children: [/*#__PURE__*/_jsx(HR, {
      marginBlockStart: "0",
      marginBlockEnd: "0"
    }), /*#__PURE__*/_jsx(Text, {
      color: "text-core-default",
      textTransform: "uppercase",
      typography: "heading-100",
      paddingInline: "400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: MessageKeys[logicOperator]
      })
    }), /*#__PURE__*/_jsx(HR, {
      marginBlockStart: "0",
      marginBlockEnd: "0"
    })]
  });
};
export default LogicGroupsDivider;